export default __webpack_public_path__ + "static/media/start-3.9ae59077.jpg";